import { z } from "zod/v4";

export const ApiEnvObject = {
    url: process.env.VITE_OBE_API_URL,
    wsServicesApiUrl: process.env.VITE_WS_SERVICES_API_URL,
} as const;

export const ApiConfigSchema = z.object({
    url: z.string(),
    wsServicesApiUrl: z.string(),
});

export type TApiConfig = z.infer<typeof ApiConfigSchema>;
